import {
  Component, OnInit, forwardRef, OnChanges,
  AfterViewInit, SimpleChanges, Input, Output, EventEmitter, HostBinding,
  ElementRef, Renderer2, ViewChild, Inject, HostListener, OnDestroy, Optional, Host,
  DOCUMENT
} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, UntypedFormControl } from '@angular/forms';

import { PanchangService } from '@otas/utils/custom-components/panchang-calendar/panchang.service';
import * as _ from 'underscore';
import moment from 'moment';
import { AppModalService } from '@otas/shared/ui/app-modal/app-modal.service';
import { AppModalRef } from '@otas/shared/ui/app-modal/app-modal.types';
import { PanchangPopupHelperService } from 'app/services/panchang-popup-helper.service';
import { DateService } from 'app/services/date.service';
import { PanchangInputHelper } from '@otas/utils/custom-components/panchang-calendar/panchang-helper';
import { contextMinBookingDate } from '@otas/shared/booking-day-policy';
import { istDayKey, istFormatTime } from '@otas/utils/custom-components/panchang-calendar/ist';
import { PoojaBookingStodaComponent } from '@otas/pooja-booking/pooja-booking-stoda/pooja-booking-stoda.component';
import { EnterKeyListenerDirective } from '@otas/utils/directives/helper/enter.directive';
declare let $;
@Component({
  selector: 'app-panchang-calendar',
  templateUrl: './panchang-calendar.component.html',
  styleUrls: ['./panchang-calendar.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PanchangCalendarComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PanchangCalendarComponent),
      multi: true,
    }
  ],
  standalone: false
})
export class PanchangCalendarComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy, ControlValueAccessor {
  @Input() required = false;
  @Input() type = 'text';
  @Input() placeholder: string;
  // @Input() formControlName: string;
  @Input('control') formControl: UntypedFormControl = new UntypedFormControl();
  @Input() class = 'form-control';
  @Output() keyChange: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();
  @Output() dateChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() monthOrYearChanged: EventEmitter<any[]> = new EventEmitter<any[]>();
  @ViewChild('input', { static: true }) inputField: ElementRef;
  @Input() @HostBinding('tabindex') tabindex = -1;
  @Input() /* @HostBinding('class')*/ isDisable = false;
  @Input() currentDate = new Date();
  @Input() options: { keyboardNavigation: boolean, startDate: Date } = { keyboardNavigation: true, startDate: null };
  chosenDate = new Date();

  inputDate = moment().format('DD/MM/YYYY');
  _weekDays: any[];
  weeks = [];
  _years: any[];
  currentMonth;
  currentEnYear;
  currentMlYear;
  currentMlMonth;
  isYear = true;
  isMonth = true;
  _months: any[];
  selectedDay: PunchangDay;
  modalref: AppModalRef<unknown>;
  lang: string;
  dateInput = 0;
  monthInput = 0;
  _inputFieldHelper: PanchangInputHelper;
  loading = false;
  @Input() poojaBookingComp: PoojaBookingStodaComponent;
  // appModal/popOverService/ps are protected: the redesigned scrolling
  // PanchangCalendarViewComponent (which extends this input component)
  // builds its month blocks straight from them.
  constructor(@Inject(DOCUMENT) private document: any, private renderer: Renderer2,
    public _elementRef: ElementRef,
    @Optional() @Host() private enterDirective: EnterKeyListenerDirective,
    protected appModal: AppModalService, protected popOverService: PanchangPopupHelperService,
    protected ps: PanchangService) {

    this.calculateWeeks();
  }

  @ViewChild('overlay', { static: true }) calendarPanel;
  onChange = (_f: any) => { };
  onTouched = () => { };

  ngOnInit() {

    if (this.poojaBookingComp) {
      this.poojaBookingComp.panchangRef = this;
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
  }
  ngAfterViewInit(): void {
    this.currentDate = this.currentDate || new Date();
    this.chosenDate = this.chosenDate || new Date();
    this.formControl.valueChanges.subscribe(
      (value) => {
        if (!value && this.inputField?.nativeElement) {
          this.inputField.nativeElement.value = '';
        }
      }
    );
  }

  inputClick(event: MouseEvent) {
    this.inputFieldHelper.inputClick(event);

  }
  writeValue(obj: any): void {
    if (!!obj) {
      if (typeof obj === 'string') {
        obj = moment(obj, obj.includes('-') ? 'DD-MM-YYYY' : 'DD/MM/YYYY').toDate();
      }
      this.inputDate = moment(obj).format('DD/MM/YYYY');
      if (this.inputField?.nativeElement) {
        this.inputField.nativeElement.value = this.inputDate;
        this.inputField.nativeElement.setSelectionRange(0, 2);
      }
      this.currentDate = DateService.stringToDateConverter(this.inputDate);
      this.chosenDate = DateService.stringToDateConverter(this.inputDate);
      this.onChange(this.chosenDate);
    } else {
      if (this.inputField?.nativeElement) {
        this.inputField.nativeElement.value = '';
      }
      this.onChange(null);
    }
  }
  public validate(c: UntypedFormControl): any {
    const controlValue = c ? c.value : null;

    if (!!controlValue && !c.errors) {
      return null;
    }
    if (this.required && !controlValue) {
      return {
        required: {
          valid: false
        }
      }
    }
    if (controlValue && c.errors && c.errors.required) {
      return null;

    }
    if (c.errors) {
      return c.errors;
    }


    // return !!controlValue ? null : this.required ? {
    //   required: {
    //     valid: false
    //   }
    // } : null;
  }
  @HostListener('document:keydown', ['$event'])
  onkeydown(event: KeyboardEvent) {
    if (event.keyCode === 122) {
      if (!this.modalref) {
        this.openCalendar(event);

      }
    }

  }
  @HostListener('focus')
  onFocus() {
    if (this.inputField?.nativeElement) {
      this.inputField.nativeElement.focus();
      this.inputField.nativeElement.setSelectionRange(0, 2);
    }
  }
  registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled === true) {
      this.formControl.disable();
      if (this.inputField?.nativeElement) {
        this.renderer.setProperty(this.inputField.nativeElement, 'disabled', isDisabled);
      }
    }
    this.isDisable = isDisabled;
  }

  keyDownListener(event: KeyboardEvent) {
    this.keyChange.emit(event)
    if (this.options.keyboardNavigation) {
      this.inputFieldHelper.keyDownListener(event);

    } else {
      event.preventDefault();
    }
  }

  inputDateChange(str: string) {
    this.inputFieldHelper.inputDateChange(str);

  }

  insertAtCaretPos(isUp: boolean) {
    this.inputFieldHelper.insertAtCaretPos(isUp);


  }
  openCalendar(eve) {

    eve.preventDefault();
    this.onTouched();
    let selDay = this.inputField?.nativeElement?.value;
    if (!selDay) {
      selDay = moment().format('DD/MM/YYYY');
    }
    let selectedDate = new Date(+selDay.split('/')[2], +selDay.split('/')[1] - 1, +selDay.split('/')[0]);
    const isDateValid = !!this.options.startDate ? DateService.isAfter(selectedDate, this.options.startDate) : true;
    if (isDateValid || DateService.isSame(selectedDate, new Date())) {
      this.currentDate = selectedDate;
    } else {
      selectedDate = new Date();
      this.currentDate = new Date();
    }
    if (this.poojaBookingComp) {
      this.loading = true;
      const date: any = this.currentDate;
      this.poojaBookingComp.getBookedDates(date * 1).then((result) => {
        // console.log(result);

        if (result) {
          this.calculateWeeks();
          this.loading = false;
          this.openAndListenModal();
        }
      });

    } else {
      this.openAndListenModal();
      this.calculateWeeks();
    }
  }
  openAndListenModal() {
    // AppModal (centered CDK overlay) hosts the overlay template — replaces
    // the legacy NgbModal open. The view inside brings its own chrome.
    this.modalref = this.appModal.open(this.calendarPanel, {
      size: 'xl', showClose: false, keyboard: false, modalClass: 'pcv-modal',
    });
    this.modalref.result.then((result) => {
      if (this.enterDirective) {
        this.enterDirective.focusTonextElementInForm(this._elementRef.nativeElement);
      }
      this.modalref = null;

    }, (reason) => {
      if (this.inputField?.nativeElement) {
        this.inputField.nativeElement.setSelectionRange(0, 2);
      }
      this.modalref = null;
      if (this.enterDirective) {
        this.enterDirective.focusTonextElementInForm(this._elementRef.nativeElement);
      }
    });
  }
  onClosePanchang() {
    if (this.modalref) {
      this.modalref.close();
      this.modalref = null;
    }
  }
  get selectedMonthDates() {

    const weeks = _.map(this.weeks);
    const dates = [];
    _.each(weeks, w => { _.each(w.week, d => { if (!!d.date) { dates.push(new Date(d.year, d.month, d.date)); } }); });
    return dates;
  }
  calculateWeeks() {

    this.currentMonth = this.ps.getMonth(this.currentDate.getMonth());
    this.currentEnYear = this.currentDate.getFullYear();
    let mlMonths = [];
    let mlyears = [];
    const weeks = _.map(this.ps.calculateWeeks(this.currentDate.getMonth(), this.currentDate.getFullYear(), true), (w: any[]) => {

      return { week: w };
    });
    weeks.forEach((w) => {
      w.week.forEach(day => {
        if (!!day.date) {
          day.isSelected =
            this.chosenDate.getDate() === day.date &&
            this.chosenDate.getFullYear() === day.year && this.chosenDate.getMonth() === day.month;

          // Block past dates logic
          // Booking-day policy (temple.ONLINE_DAY_END via the shared util):
          // counter app keeps today always bookable; portal follows the full
          // policy. null minimum (PAST) blocks nothing. Compared as IST
          // calendar-day keys so a browser abroad blocks the same days as a
          // Kerala machine.
          const minBookable = contextMinBookingDate();
          const cellDayKey = day.year * 10000 + (this.currentDate.getMonth() + 1) * 100 + day.date;
          if (minBookable && cellDayKey < istDayKey(minBookable)) {
            day.blocked = true;
          }

          if (day.blocked && day.isSelected) {
            this.chosenDate = moment(this.chosenDate).add(1, 'day').toDate();
            day.isSelected = false;
          }

          this.lang = sessionStorage.getItem('language');
          mlyears.push(day.mlDetails.mlyear);
          mlMonths.push(this.lang === 'malayalam' ? day.mlDetails.mlMasaName : day.mlDetails.masaName);
          const nd: Date = day.mlDetails.naksatra.end;
          const td: Date = day.mlDetails.tithi.end;
          day.mlDetails.starName = this.lang === 'malayalam' ? day.mlDetails.naksatra.mlMalayalam : day.mlDetails.naksatra.enMalayalam;
          if (!!day.mlDetails.secondStar) {
            const secondStarEndTime: Date = day.mlDetails.secondStar.end;
            day.mlDetails.secondstarName =
              this.lang === 'malayalam' ? day.mlDetails.secondStar.mlMalayalam : day.mlDetails.secondStar.enMalayalam;
            day.mlDetails.secondStar.startAndend = istFormatTime(secondStarEndTime);
          }
          if (!!day.mlDetails.secondTithi) {
            const secondStarEndTime: Date = day.mlDetails.secondTithi.end;
            day.mlDetails.secondTithiName =
              this.lang === 'malayalam' ? day.mlDetails.secondTithi.mlMalayalam : day.mlDetails.secondTithi.enMalayalam;
            day.mlDetails.secondTithi.startAndend = istFormatTime(secondStarEndTime);
          }
          day.mlDetails.tithiName = this.lang === 'malayalam' ? day.mlDetails.tithi.mlMalayalam : day.mlDetails.tithi.enMalayalam;
          // Bracket times on the IST wall clock (was host-local).
          day.mlDetails.naksatra.startAndend = istFormatTime(nd);
          day.mlDetails.tithi.startAndend = istFormatTime(td);
          this.popOverService.content.forEach((c) => {
            if (DateService.isSame(c.date, new Date(day.year, day.month, day.date))) {
              day.content = c.content;
              day.title = c.title;
              day.isPartial = c.isPartial;
            }
          });

        }
      });
      mlMonths = _.uniq(mlMonths);
      mlyears = _.uniq(mlyears);

      this.currentMlYear = mlyears.length > 1 ? ((mlyears[0] > mlyears[1] ? mlyears[1] : mlyears[0]) + '-' + (mlyears[0] > mlyears[1] ? mlyears[0] : mlyears[1])) : mlyears[0];
      this.currentMlMonth = mlMonths.length > 1 ? mlMonths[0] + '-' + mlMonths[1] : mlMonths[0];
    });


    this.weeks = weeks;
    if (this.weeks[0] && !!this.weeks[0].week[0].date) {
      const zeroIndexDate = this.weeks[0].week[0].date;
      this.currentMlMonth = mlMonths.length > 1 && zeroIndexDate > 1 ? mlMonths[1] + '-' + mlMonths[0] : this.currentMlMonth;
    }
    this.monthOrYearChanged.emit(this.selectedMonthDates);

  }

  yearChange(value) {
    if (!!value) {
      this.currentEnYear = +value;
      this.currentDate.setFullYear(this.currentEnYear);
      const date: any = this.currentDate;
      if (this.poojaBookingComp) {
        this.loading = true;
        this.poojaBookingComp.getBookedDates(date * 1).then((result) => {
          if (result) {
            this.loading = false;
            this.calculateWeeks();
          }
        });
      } else {
        this.calculateWeeks();
      }
      this.isMonth = true;
      this.isYear = true;
    }
  }

  monthChange(value) {
    if (!!value) {
      const index = _.findLastIndex(this.months, e => e.en === this.currentMonth.en);
      this.currentDate.setMonth(index);
      const date: any = this.currentDate;
      if (this.poojaBookingComp) {
        this.loading = true;
        this.poojaBookingComp.getBookedDates(date * 1).then((result) => {
          if (result) {
            this.loading = false;
            this.calculateWeeks();
          }
        });
      } else {
        this.calculateWeeks();
      }
      this.isYear = true;
      this.isMonth = true;
    }

  }
  nextMonth() {
    this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1);
    const date: any = this.currentDate;
    if (this.poojaBookingComp) {
      this.loading = true;
      this.poojaBookingComp.getBookedDates(date * 1).then((result) => {
        if (result) {
          this.loading = false;
          this.calculateWeeks();
        }
      });
    } else {
      this.calculateWeeks();
    }
  }
  prevMonth() {
    this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1);
    const date: any = this.currentDate;
    if (this.poojaBookingComp) {
      this.loading = true;
      this.poojaBookingComp.getBookedDates(date * 1).then((result) => {
        if (result) {
          this.loading = false;
          this.calculateWeeks();
        }
      });
    } else {
      this.calculateWeeks();
    }
  }
  onDateSelect(dateStr: string) {
    if (!!dateStr) {
      if (this.inputField?.nativeElement) {
        this.inputField.nativeElement.value = dateStr;
        this.inputField.nativeElement.setSelectionRange(0, 2);
      }
      const date = moment(dateStr, 'DD/MM/YYYY').toDate();
      this.onChange(this.chosenDate = date);
      this.dateChanged.emit(dateStr);
      if (this.modalref) {
        this.modalref.close(this.chosenDate);
        this.modalref = null;
      }
    }
  }

  choosedate(day, weeks, isKeyBoard = false) {
    if (!!day.date) {

      const selectedDay: PunchangDay = {
        enyear: day.year,
        date: day.date,
        enmonth: this.currentDate.getMonth() + 1,
        mlMonth: day.mlDetails.mlmonth,
        mlYear: day.mlDetails.mlyear,
        naksatra: day.mlDetails.naksatra,
        tithi: day.mlDetails.tithi
      };
      this.selectedDay = selectedDay;
      const date = new Date(selectedDay.enyear, selectedDay.enmonth - 1, selectedDay.date);

      // Same booking-day policy as the render pass: a click on a day earlier
      // than the context minimum is rejected (null minimum = PAST allows all).
      // IST calendar-day keys, like the render pass.
      const minBookable = contextMinBookingDate();
      const clickedDayKey = selectedDay.enyear * 10000 + selectedDay.enmonth * 100 + selectedDay.date;

      if (!minBookable || istDayKey(minBookable) <= clickedDayKey) {
        const isDateValid = !!this.options.startDate ? DateService.isAfter(date, this.options.startDate) : true;

        if ((isDateValid || DateService.isSame(date, new Date())) && day.isPartial !== false) {
          weeks.forEach(e => {
            const selDay = _.find(e.week, el => el.isSelected);
            if (!!selDay) {
              selDay.isSelected = false;
            }
          });
          day.isSelected = true;
          // tslint:disable-next-line:max-line-length
          if (this.inputField?.nativeElement) {
            this.inputField.nativeElement.value = `${selectedDay.date < 10 ? '0' + selectedDay.date : selectedDay.date}/${selectedDay.enmonth < 10 ? '0' + selectedDay.enmonth : selectedDay.enmonth}/${selectedDay.enyear}`;
            this.inputField.nativeElement.setSelectionRange(0, 2);
          }
          this.onChange(this.chosenDate = date);
          if (!isKeyBoard) {
            this.modalref.close(this.chosenDate);
            this.modalref = null;
          }
        } else {
          // this.inputField.nativeElement.value = '';
          const currentDate = new Date();
          const currentDay = currentDate.getDate();
          const currentMonth = currentDate.getMonth() + 1;
          const currentYear = currentDate.getFullYear();
          if (this.inputField?.nativeElement) {
            this.inputField.nativeElement.value = `${currentDay < 10 ? '0' + currentDay : currentDay}/${currentMonth < 10 ? '0' + currentMonth : currentMonth}/${currentYear}`;
          }
          this.onChange(currentDate);
        }

      }

    }

  }

  ngOnDestroy() {
    if (this.modalref) {
      this.modalref.dismiss('close');
    }
    this.popOverService.content = [];
    this.popOverService.date = undefined;
  }

  get weekDays(): any[] {
    if (!this._weekDays) {
      this._weekDays = this.ps.weekdaysLookup;
    }
    return this._weekDays;
  }

  get years(): any[] {
    if (!this._years) {
      this._years = this.ps.getYears();
    }
    return this._years;
  }

  get months(): any[] {
    if (!this._months) {
      this._months = this.ps.getMonths();
    }
    return this._months;
  }

  get inputFieldHelper(): PanchangInputHelper {
    if (!this._inputFieldHelper) {
      this._inputFieldHelper = new PanchangInputHelper(this.document, this);
    }
    return this._inputFieldHelper;
  }
}

export class PunchangDay {
  enyear: number;
  date: number;
  enmonth: number;
  mlMonth: number;
  mlYear: number;
  naksatra: { name: string, start: Date, end: Date };
  tithi: { name: string, start: Date, end: Date };
}
